module.exports = __webpack_public_path__ + "assets/img/Travel_009.f7af55d9-ps.jpg";